import restApi from '@infrastructure/api/restApi'
import { camelizeRespDataKeys } from '@infrastructure/api/utils'

export default {
  getData: () => restApi.get('/overview').then(camelizeRespDataKeys)
}
